import api, { getResponseError } from '../../services/api'
import {
  AdminTransferCalculatedValue,
  AdminTransferItem,
  AdminTransferRequest,
  AdminTransferResponse,
  GetAdminCalculatedValueRequest,
  GetAdminTransferByTenantIdRequest,
} from '../types/Admin'
import { TResponse } from '../types/ErrorResponse'

const transfer = async ({
  data,
}: {
  data: AdminTransferRequest
}): Promise<TResponse<AdminTransferResponse>> => {
  try {
    const { data: response } = await api.post('/Admin/transfer', data)
    if (response) {
      return {
        success: true,
        code: 0,
        error: '',
        data: response,
      }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error: any) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const getCalculatedValue = async ({
  tenantId,
}: GetAdminCalculatedValueRequest): Promise<
  TResponse<AdminTransferCalculatedValue>
> => {
  try {
    const { data } = await api.get<AdminTransferCalculatedValue>(
      `/Admin/transfer/${tenantId}/calculated`
    )
    if (data) {
      return { success: true, code: 0, error: '', data }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const getTransfersByTenantId = async ({
  tenantId,
}: GetAdminTransferByTenantIdRequest): Promise<
  TResponse<AdminTransferItem[]>
> => {
  try {
    const { data } = await api.get<AdminTransferItem[]>(
      `/Admin/transfer/${tenantId}/list`
    )
    if (data) {
      return { success: true, code: 0, error: '', data }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const AdminController = {
  transfer,
  getCalculatedValue,
  getTransfersByTenantId,
}

export default AdminController
